export const GameRegistrationTypes = {
    ALL: {
        id: "ALL",
        title: "همه"
    },
    APPROVED: {
        id: "APPROVED",
        title: "تایید شده"
    },
    PENDING: {
        id: "PENDING",
        title: "در حال بررسی"
    },
    REJECTED: {
        id: "REJECTED",
        title: "رد شده"
    },
    CANCELLED: {
        id: "CANCELLED",
        title: "لغو شده"
    },
}

export function getGameRegistrationStatus(status) {
    switch (status) {
        case GameRegistrationTypes.APPROVED.id: {
            return GameRegistrationTypes.APPROVED.title
        }
        case GameRegistrationTypes.PENDING.id: {
            return GameRegistrationTypes.PENDING.title
        }
        case GameRegistrationTypes.REJECTED.id: {
            return GameRegistrationTypes.REJECTED.title
        }
        case GameRegistrationTypes.CANCELLED.id: {
            return GameRegistrationTypes.CANCELLED.title
        }

    }
}